export const PERFORMANCE_INSIGHTS_TYPE = {
  ISSUE: 'issue',
  RECOMMENDATION: 'recommendation',
};
export const PERFORMANCE_INSIGHTS_ISSUE = {
  BUDGET: 'BudgetConstraint',
  BID: 'LimitedByAutoBidTargetPerf',
};
export const PERFORMANCE_INSIGHTS_ACTION = {
  VIEW_ALL_ISSUES: _TL_('View all issues'),
  SAVE: _TL_('Save'),
  VIEW_RECOMMENDATIONS: _TL_('View recommendations'),
  VIEW_RECOMMENDATION: _TL_('View recommendation'),
  APPLY_RECOMMENDATION: _TL_('Apply recommendation'),
  CLOSE: _TL_('Close'),
};
export const PERFORMANCE_INSIGHTS_POPUP_CONFIG = {
  [PERFORMANCE_INSIGHTS_TYPE.ISSUE]: {
    [PERFORMANCE_INSIGHTS_ISSUE.BUDGET]: {
      title: _TL_('Campaign limited by budget'),
      chartTitle: _TL_('Impressions between {{startDate}} and {{endDate}}'),
      description: _TL_('Your campaign had {{missedImpressions}} fewer impressions on {{endDate}} due to a limited budget.'),
      pitching: _TL_('Increasing the budget may result in more ad displays, potentially reaching more customers and improving ROI.'),
      actionDetails: [
        _TL_('Increasing your campaign budget from {{localizedActualBudget}} to {{localizedRecommendedBudget}}.'),
      ],
      action: PERFORMANCE_INSIGHTS_ACTION.VIEW_ALL_ISSUES,
      successMessage: _TL_('Your daily budget for {{campaignName}} is changed.'),
      failMessage: _TL_('You have fail to change daily budget of {{campaignName}}, please try again'),
    },
    [PERFORMANCE_INSIGHTS_ISSUE.BID]: {
      title: _TL_('Campaign performance limited by target cost per acquisition (CPA)'),
      chartTitle: _TL_('Conversions between {{startDate}} and {{endDate}}'),
      description: _TL_('Your campaign is projected to miss {{missedConversions}} conversions between {{startDate}} and {{endDate}} due to this issue.'),
      pitching: _TL_('Increasing your budget may result in more ad visibility over the next few days.'),
      actionDetails: [
        _TL_('Changing target cost per acquisition (CPA) from {{localizedLatestActualTarget}} to {{localizedLatestSuggestTarget}}.'),
        _TL_('Changing target cost per acquisition (CPA) from {{localizedLatestActualTarget}} to {{localizedVerticalTarget}} to align with campaigns in your vertical.'),
      ],
      action: PERFORMANCE_INSIGHTS_ACTION.VIEW_ALL_ISSUES,
      successMessage: _TL_('Your target cost per acquisition (CPA) for {{campaignName}} is changed.'),
      failMessage: _TL_('You have fail to change target cost per acquisition (CPA) of {{campaignName}}, please try again'),
    },
  },
};

export const PERFORMANCE_INSIGHTS_PANEL_CONTAINER = '.performance-insights-popover-container';

export const RADIO_VALUE = {
  suggest: 'suggest',
  vertical: 'vertical',
};

export const EXTERNAL_LINK = {
  RECOMMENDATION: '/campaign/vnext/recommendations/All',
};
